import type { ComponentType } from 'react'

import { reloadForNewDeployment } from '@/lib/deploy-chunk-recovery'

/** Shown only if reload does not unload the document (should be rare). */
function ChunkLoadReloading(): null {
	return null
}

/**
 * After a prod deploy, hashed chunk URLs change; in-flight SPAs often get 404/failed dynamic imports.
 * Reload via shared recovery (debounced) instead of routing to another lazy page.
 */
export const lazyWithErrorHandling = (importFunc: () => Promise<{ Page: ComponentType<any> }>) => {
	return async () => {
		try {
			const mod = await importFunc()
			// Bad deploy / CDN HTML: `import()` can resolve without throwing but give no `Page` — same
			// TypeError RR shows: "Cannot destructure property 'Page' ... as it is undefined".
			if (mod == null || !('Page' in mod) || mod.Page == null) {
				// eslint-disable-next-line no-console -- deploy visibility
				console.warn('[platform] Route module loaded without Page export; reloading.', mod)
				reloadForNewDeployment()
				return { Component: ChunkLoadReloading }
			}
			return { Component: mod.Page }
		} catch (error) {
			// eslint-disable-next-line no-console -- deploy / ops visibility
			console.warn('[platform] Route chunk failed to load (often post-deploy). Reloading.', error)
			reloadForNewDeployment()
			return { Component: ChunkLoadReloading }
		}
	}
}
